export default __webpack_public_path__ + "static/media/adaptive-shield-long.b415d0ea.svg";